/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ScaleOralParticipation = ({ rowData }) => {
  const classes = useStyles();
  return (
    <div className={classes.gradeDetails}>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Prise de parole sollicitée :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.speechRequested || '0'}
          /5
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Prise de parole spontanée :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.spontaneousSpeaking || '0'}
          /5
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Présence et implication :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.participation || '0'}
          /10
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.totalGrade}>
          Total :
        </Typography>
        <Typography className={classes.totalGrade}>
          {parseFloat(rowData?.grade?.speechRequested || 0)
            + parseFloat(rowData?.grade?.spontaneousSpeaking || 0)
            + parseFloat(rowData?.grade?.participation || 0)}
          /20
        </Typography>
      </div>
    </div>
  );
};

export default ScaleOralParticipation;
